<template>
    <div v-if="showIntro || canEdit"
         :id="key"
         v-html="text"
         @click="edit"/>
</template>

<script>
export default {
    props: {
        route: String
    },
    data () {
        return {
            id: null,
            text: null,
            canEdit: false,
            showIntro: false
        }
    },
    computed: {
        key () {
            return this.route ? this.route : this.$router.currentRoute.name
        }
    },
    mounted () {
        //  set admin flag
        if (this.$user.isSuperAdmin()) {
            this.canEdit = true
            this.showIntro = true
        }
        //  retrieve intro text
        if (this.key) {
            // check cache first
            let text = this.$store.state.intros ? this.$store.state.intros[this.key] : null
            if (text || (text === null)) {
                this.text = text
            } else {
                const filters = {
                    route: {
                        field: 'route',
                        value: this.key
                    }
                }
                this.$api.getItems(this, 'intro', filters, {})
                    .then((intros) => {
                        let text = null
                        if (intros && (intros.length === 1)) {
                            const intro = intros[0]
                            this.id = intro.id
                            this.text = intro.content
                            this.showIntro = true
                            text = intro.content
                        }
                        this.$store.dispatch('submit', {
                            mutation: 'intros',
                            route: this.key,
                            text: text
                        })
                    })
            }
        }
    },
    methods: {
        edit () {
            if (this.canEdit) {
                if (this.id) {
                    const routeData = this.$router.resolve({ name: 'introEdit', params: { introId: this.id } })
                    window.open(routeData.href, this.key)
                } else {
                    const routeData = this.$router.resolve({ name: 'introCreate', query: { route: this.key } })
                    window.open(routeData.href, this.key)
                }
            }
        },
    },
}
</script>

<style lang="scss">
.intro {
    margin-left: .5em;
}
</style>
